import api from './api';

export const getCreatorEarnings = async () => {
  const response = await api.get('/paywall/admin/creator-earnings');
  return response.data;
};

const earningsService = { getCreatorEarnings };
export default earningsService;
